export default class ItemModalContentPositionEnum {
    static get DEFAULT() {
        return 'default';
    }

    static get CENTERED() {
        return 'centered';
    }

    static get options() {
        return {
            DEFAULT: this.DEFAULT,
            CENTERED: this.CENTERED
        };
    }
}
